module.exports = __webpack_public_path__ + "static/media/dem_by_han.39c691bf.png";